import PropTypes from "prop-types";
import React from "react";
import { NavLink } from "react-router-dom";
// import IconBoxData from '../../data/iconBox/icon-box.json';
// import IconBox from '../../components/IconBox/IconBox.jsx';
import SectionTitle from "../../components/SectionTitles/SectionTitle";
import NewGif from "../../components/Gif/NewGif";
// import Btn from "../../components/Btn/Btn";

const ServiceIconBox = ({ classOption }) => {
  return (
    <div className={`section section-padding-t50-b0 ${classOption}`}>
      <div className="container">
        <SectionTitle title="Anouncement" />

        <div className="conference-ind">

        </div>


        <div className="row row-cols-1 mb-n6" id="anounce">
          <ul>
            {/* <li>
              <h5>
              <div className="font-red">
              <NewGif />{" "}
              <a href="./images/backgroud/back_shenzhen.jpg">
              Welcome to join ICSI&apos;2023 in Shenzhen, China, July 14th-18th, 2023
              </a>
              ICSI&apos;2022 is ready for all authors and participants, welcome to our exciting conference ICSI&apos;2022!
              </div>
              </h5>
            </li> */}
            {/* <br></br>
            <br></br> */}
            {/* <li>
              <h5>
              <div>
              <NewGif />{" "}
              <a href="./gallery">
              Congratulations! ICSI&apos;2022 has been held successfully on 15th - 19th, July.
              </a>
              ICSI&apos;2022 is ready for all authors and participants, welcome to our exciting conference ICSI&apos;2022!
              </div>
              </h5>
            </li> */}

            {/* <li>
              <h5>
              <NewGif />{" "}
              <a href="https://link.springer.com/book/10.1007/978-981-97-0837-6">
              <div>
                Conference proceedings! Click here!
              </div>
              </a>
              </h5>
            </li> */}
            {/* <br></br> */}
            {/* <li>
              <h5>
              <NewGif />{" "}
              <a href="./gallery">
              <div>
              Our wonderful moments!
              </div>
              </a>
              </h5>
            </li> */}
            {/* <li>
              <h5>
              <NewGif />{" "}
              <div>
              DMBD2025 will be held in Harbin, China. Welcome to submit papers to DMBD2025!
              </div>

              </h5>
            </li> */}
            {/* <li>
              <h5>
              <NewGif />{" "}
              Warm congratulations on the successful conclusion of DMBD2025!

              </h5>
            </li> */}

            {/* <li>
              <h5>
              <NewGif />{" "}
              <a href="./files/ICSI2022-Program.pdf">
              <div>
              The Final Program Booklet of ICSI&apos;2022 is ready for download!
              </div>
              </a>
              </h5>
            </li> */}
            {/* <li>
              <div className="vertical_center">
                <div >
              <NewGif />
                </div>
              <h5>
              <a href="./proceeding">
              The ICSI&apos;2022 Proceedings (Springer-Nature LNCS 13344 and LNCS 13345) are available online for all participants 
              <br></br>
              to download, for free, from July 08, 2022 to August 08, 2022!
              </a>
              </h5>
              </div>
            </li> */}
            {/* <li>
              <h5>
              <NewGif />{" "}
              <a href="./program">
              <div>
              The scheduled timetables of ICSI&apos;2022 presentations have been made for all participants!
              </div>
              </a>
              </h5>
            </li> */}
            {/* <li>
              <h5>
              <NewGif />{" "}
              <a href="./competition_result">
              <div>
              The FINAL results of ICSI-OC&apos;2022 have been announced online!
              </div>
              </a>
              </h5>
            </li> */}

            <div className="space-40"></div>
            {/* <li>
              <h5>
                <a href="./competition">
                  <del>

                ICSI-OC&apos;2022: &quot; Competition on Single Objective
                Bounded Optimization Problems&quot; call for participants!
                  </del>
                </a>
                </h5>
              </li> */}

            {/* <li>
              <h5>
                <NewGif />{" "}
                to be added!
                <p></p>
              </h5>
            </li> */}

          {/* <li>
              <h5>
                <div className="font-red">
                  <NewGif />{" "}
                  <a href="./registration_pub">

                    <del>
                    The author registration for DMBD&apos;2025 is open! Registration deadline December 10th.
                    </del>
                  </a>
                </div>
              </h5>
            </li>

          <li>
              <h5>
                <div className="font-red">
                  <NewGif />{" "}
                  <a href="./registration_pub">

                    <del>
                    The public registration for DMBD&apos;2025 is open. Everyone is welcome to register and participate in our conference!
                    </del>
                  </a>
                </div>
              </h5>
            </li> */}
            {/*
            <li>
              <h5>
                <div className="font-red">
                  <a href="./reservation">

                    <del>
                    <NewGif />{" "}
                    Hotel room reservation is open! Deadline : Dec. 3rd
                    </del>
                  </a>
                </div>

              </h5>
            </li> */}

            {/* <li>
              <h5>
                <div className="font-red">
                  <a href="./program">

                    <del>
                    <NewGif />{" "}
                    Program arrangement released!
                    </del>
                  </a>
                </div>

              </h5>
            </li> */}

    

{/* 
            <li>
              <h5>
                <div className="font-red">
                  <a href="./registration">

                    <del>
                    <NewGif />{" "}
                    Paper Registration will be open from Nov 13! Paper registration deadline: Nov 26.
                    </del>
                  </a>
                </div>

              </h5>
            </li> */}
            {/* <li>
              <h5>
                <div className="font-red">
                  <a href="./registration">
                    <NewGif />{" "}

                    <del>
                    The notification letters for DMBD&apos;2023 submissions have been sent to the corresponding author(s) of each DMBD&apos;2023
                    submission!
                    </del>
                  </a>
                </div>

              </h5>
            </li> */}


            {/* <li>
              <h5>
                <del>
                  The notification letters for ICSI&apos;2022 submissions have
                  been sent to the corresponding author(s) of each
                  ICSI&apos;2022 <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;submission on April 15, 2022.
                </del>
              </h5>
            </li> */}
            {/* <li>
              <h5>
                <NewGif />{" "}
                <a href="./deadlines">
                  <del>
                    Final Deadline for Paper Submission: October 31st, 2023 <strong>(FIXED)</strong>
                  </del>
                </a>
              </h5>
            </li>

            <li>
              <h5>
                <NewGif />{" "}
                <a href="./deadlines">
                  <del>
                    Notification of acceptance, Author registration Deadline Delay until November.
                  </del>
                </a>
              </h5>
            </li>

            <li>
              <h5>
                <NewGif />{" "}
                <a href="./deadlines">
                  <del>
                    Final Deadline for Paper Submission: September 28th, 2023
                  </del>
                </a>
              </h5>
            </li>
            <li>
              <h5>
                <NewGif />{" "}
                <a href="./deadlines">
                  <del>
                    Deadline for Paper Submission: August 31st, 2023 !
                  </del>
                </a>
              </h5>
            </li> */}
                        {/* <li> */}
              {/* <h5> */}
                {/* <NewGif />{" "} */}
                {/* <a href="./submission" className="font-red"> */}
                  {/* <del>  */}
                    {/* Submission system is open! Click Here! (Fixed Final Deadline October 31st) */}
{/* We sincerely apologize that due to the increased number of submissions, the notification of acceptance will be postponed to November 30. For any special circumstances, please contact the organizing committee by email or wechat. */}
                  {/* </del> */}
                {/* </a> */}
              {/* </h5> */}
            {/* </li> */}
            

            
            
            {/* <li>
              <h5>
                <div className="font-red">
                  <NewGif />{" "}
                  <a href="./registration_pub">

                    <del>
                    The public registration for DMBD&apos;2024 is open. Everyone is welcome to register and participate in our conference!
                    </del>
                  </a>
                </div>
              </h5>
            </li> */}
              {/* <li>
              <h5>
                <div className="font-red">
                  <a href="./accommodation">

                    <del>
                    <NewGif />{" "}
                    Venue and accommodation are posted. We offer rooms at a negotiated rate.
                    </del>
                  </a>
                </div>

              </h5>
            </li> */}

            {/* <br></br> */}
            {/* <li>
              <h5>
                <div className="font-red">
                  <a href="./registration">

                    <del>
                    <NewGif />{" "}
                    The acceptance results have been sent to the corresponding author&apos;s email address, please check and complete registration in time. Registration deadline November 15 !
                    </del>
                  </a>
                </div>

              </h5>
            </li> */}
            {/* <li>
              <h5>
                <div className="font-red">
                  <a href="./registration">

                    <del>
                    <NewGif />{" "}
                    Paper Registration will be open from Nov 1st! Paper registration deadline: Nov 15th.
                    </del>
                  </a>
                </div>

              </h5>
            </li> */}

            {/* <li>
              <h5>
                <NewGif />{" "}
                <a href="files/CFP.pdf">
                  <del>
                    DMBD&apos;2024 Final call for papers! (DDL October 18th)
                  </del>
                </a>
              </h5>
            </li> */}
            
            <li>
              <h5>
                <NewGif />{" "}
                <div className="font-red">
                <NavLink to={process.env.PUBLIC_URL + "/deadlines"}>
                  {/* <del> */}
                  At the authors&apos; request, the paper submission deadline has been extended to October 30, 2026, and this is a fixed deadline.
                  {/* </del> */}
                </NavLink>
                </div>
              </h5>
            </li>

            <li>
              <h5>
                <NewGif />{" "}
                <div className="font-red">
                <NavLink to={process.env.PUBLIC_URL + "/sponsors"}>
                  {/* <del> */}
                  We have established a partnership with the journal MAKE (IF=8.4), and outstanding papers will be recommended to MAKE.
                  {/* </del> */}
                </NavLink>
                </div>
              </h5>
            </li>
            <br></br>

            <li>
              <h5>
                {/* <NewGif />{" "} */}
                <a href="files/CFP.pdf">
                {/* <a> */}
                  {/* <del> */}
                    DMBD&apos;2026 call for papers!
                  {/* </del> */}
                </a>
              </h5>
            </li>
            <li>
              <h5>
                {/* <NewGif />{" "} */}

                <NavLink to={process.env.PUBLIC_URL + "/specialsession"}>
                  {/* <del> */}
                  DMBD&apos;2026 call for special sessions!
                  {/* </del> */}
                </NavLink>

              </h5>
            </li>
            <li>
              <h5>
                {/* <NewGif />{" "} */}
                <NavLink to={process.env.PUBLIC_URL + "/tutorials"}>
                  {/* <del> */}
                    DMBD&apos;2026 call for tutorial proposals!
                    {/* </del>  */}
                </NavLink>
              </h5>
            </li>
            <br></br>
            <li>
              <h5>
                <div className="font-red">
                {/* <NewGif />{" "} */}
                <NavLink to={process.env.PUBLIC_URL + "/topic"}>
                  {/* <del> */}
                    DMBD&apos;2026 Topic Updated!
                  {/* </del> */}
                </NavLink>
                </div>
              </h5>
            </li>
            {/* <li>
              <h5>
                <NewGif />{" "}
                <a >
                  
                  The DMBD 2025 is expected to be held in Beijing in December 2025. Detailed information will be released soon, so please stay tuned.
                   
                </a>
              </h5>
            </li>
            <br></br> */}
             {/* <h5>Approved Special Sessions</h5>*/}
            <br></br>
            <li>
              <h5>
                {/* <NewGif />{" "} */}
                <div className="font-red">
                <NavLink to={process.env.PUBLIC_URL + "/specialsession"}>
                  {/* <del> */}
                  Approved Special Session 1: Big Data Mining and Foundation Models for Explainable Multimodal Diagnosis in Precision Healthcare
                  {/* </del> */}
                </NavLink>
                </div>
              </h5>
            </li>

            {/* <li>
              <h5>
                <NewGif />{" "}
                <a href="./specialsession#session1">
                  <del>
                  Special Session 2: Harnessing the Power of Financial Large Models and Data Mining: Innovations, Applications, and Ethical Considerations
                  </del>
                </a>
              </h5>
            </li> */}
{/*
            <li>
              <h5>
                <NewGif />{" "}
                <a href="./specialsession#session2">
                  <del>
                  Special Session 2: Efficient Evolutionary Deep Learning.
                  </del>
                </a>
              </h5>
            </li>

            <li>
              <h5>
                <NewGif />{" "}
                <a href="./specialsession#session3">
                  <del>
                  Special Session 3: Data Analysis and Security in Mobile Networks.
                  </del>
                </a>
              </h5>
            </li>

            <li>
              <h5>
                <NewGif />{" "}
                <a href="./specialsession#session4">
                  <del>
                  Special Session 4: Modeling and Optimization Research of Smart Integrated Energy System.
                  </del>
                </a>
              </h5>
            </li>

            <li>
              <h5>
                <NewGif />{" "}
                <a href="./specialsession#session5">

                  Special Session 5: Advances in Big-Model empowered Fintech and Quantitative Investment
                </a>
              </h5>
            </li>

            <li>
              <h5>
                <NewGif />{" "}
                <a href="./specialsession#session6">

                  Special Session 6: Data mining and optimization in data space
                </a>
              </h5>
            </li>

            <li>
              <h5>
                <NewGif />{" "}
                <a href="./specialsession#session7">
                  Special Session 7: Digital twin and digital transformation methods, technologies and applications
                </a>
              </h5>
            </li>

            <li>
              <h5>
                <NewGif />{" "}
                <a href="./specialsession#session8">
                  Special Session 8: 1st International Workshop on Evolutionary Computing for Healthcare
                </a>
              </h5>
            </li>
            <h5>Approved Tutorials</h5>
            */}

            {/* <li> */}
              {/* <h5> */}
                {/* <NewGif />{" "} */}
                {/* <a href="./tutorials" className="font-red"> */}
                {/* <del> */}
                  {/* Approved Tutorial 1: Trustworthiness in Data Science: Fairness, Privacy and Explainability. */}
                {/* </del> */}
                {/* </a> */}
              {/* </h5> */}
            {/* </li>  */}
            {/* <li>
              <h5>
                <a href="./special-session#session1">
                  <del>
                    Special Session 1: &quot;Swarm Intelligence and Machine
                    Learning in Management Science and Industrial
                    Applications&quot;{" "}
                  </del>
                </a>
              </h5>
            </li> */}
            {/* <li>
              <h5>
                <a href="./special-session#session2">
                  <del>
                    Special Session 2: &quot;Brain Storm Optimization Algorithm
                    and Its Applications&quot;{" "}
                  </del>
                </a>
              </h5>
            </li> */}
          </ul>
        </div>
        {/* <div>
        Notice: 
        Due to the rapid overspreading of Omicron variant of COVID-19, even though the ICSI 2022 was planned to be held in a hybrid mode, after carefully evaluating most of announcements and guidance regarding to COVID-19, and too much restrictions on traveling to the venue, released by relevant national departments and Xi&apos;an municipal, the ICSI 2022 organizing committee has made the decision that our ICSI 2022 will continue as scheduled on July 15-19, by being converted to a fully virtual conference. The ICSI 2022 technical team will be providing the ability for the authors with accepted papers to present their work through an interactive online platform or video replay. The presentations of accepted authors will be made available to all registered attendees online.
        </div> */}
        <div className="conference-ind">

          <div className="online-info" >
            {/* Notice: to be added */}
            {/* Due to the rapid overspreading of Omicron variant of COVID-19, even though the ICSI 2022 was planned to be held in a hybrid mode, after carefully evaluating most of announcements and guidance regarding to COVID-19, and too much restrictions on traveling to the venue, released by relevant national departments and Xi&apos;an municipal, the ICSI 2022 organizing committee has made the decision that our ICSI 2022 will continue as scheduled on July 15-19, by being converted to a fully virtual conference. The ICSI 2022 technical team will be providing the ability for the authors with accepted papers to present their work through an interactive online platform or video replay. The presentations of accepted authors will be made available to all registered attendees online. */}
          </div>
        </div>
        {/* <div className="double-sub">
          <Btn
          name="Submit English paper"
          linkage={process.env.PUBLIC_URL + "/submission"}
          />
          <div className="space"></div>
          <Btn
            name="Submit Chinese paper"
            linkage={process.env.PUBLIC_URL + "/submission_zn"}
          />
        </div> */}
      </div>
    </div>
  );
};

ServiceIconBox.propTypes = {
  classOption: PropTypes.string,
};
ServiceIconBox.defaultProps = {
  classOption: "section section-padding-t90-b100",
};

export default ServiceIconBox;
